import { createSelector } from 'reselect'
import { State } from 'index'

const storeShippingSelector = (state: State) => state.storeShipping

export const getStoreShippings = createSelector([storeShippingSelector], (state) => state.shippings)
